//export const ApiHippoUrl = "https://app.hippo.uz";
export const ApiHippoUrl = "https://staging.hippo.uz";